import {logTmrEvent} from '@web-catalog/utils/analytics';

import {YmLogger} from './YmLogger';

export const logMenuOpen = () => {
  logTmrEvent({logEvent: 'menu.open'});

  YmLogger.logMenuOpenClick();
};

export const logMenuClose = () => {
  logTmrEvent({
    logEvent: 'menu.close',
  });
};

export const logMenuItemClick = (title: string) => {
  switch (title) {
    case 'Приложения': {
      logTmrEvent({
        logEvent: 'menu.apps.click',
      });

      YmLogger.logAppsClick();
      return;
    }
    case 'Игры': {
      logTmrEvent({
        logEvent: 'menu.games.click',
      });

      YmLogger.logGamesClick();
      return;
    }
    case 'Разработчикам': {
      logTmrEvent({
        logEvent: 'menu.dev.click',
      });

      YmLogger.logDevClick();
      return;
    }
    case 'Помощь': {
      logTmrEvent({
        logEvent: 'menu.support.click',
      });

      YmLogger.logSupportClick();
    }
  }
};
